import React, { Component } from "react";
import { connect } from "react-redux";
import tasksToDo from "../../helpers/tasks";
import checkIcon from "../../images/check.png";
import todoIcon from "../../images/todo.png";
import spinner from "../../images/spinner.svg";
import { Collapse } from "reactstrap";
import { Button } from "react-bootstrap";
import { getCodeWars } from "../../api/user";
import breakpoint from '../../helpers/breakpoints';
import { Box } from "@material-ui/core";

const codeWarsUser = "https://www.codewars.com/users/";

class CodeWars extends Component {
  constructor(props) {
    super(props);
    this.state = this.initialState();
  }

  initialState() {
    return {
      users: [],
      collapse: {},
      loading: false,
    };
  }

  componentDidMount() {
    this.loadUsers();
  }

  loadUsers() {
    this.setState({ loading: true });
    getCodeWars(this.props.group)
      .then(res => {
        this.setState({ users: res.data, loading: false });
      })
      .catch(err => console.log(err));
  }

  showHide(username) {
    const collapse = this.state.collapse;
    collapse[username] = !this.state.collapse[username];
    this.setState({ collapse: collapse });
  }

  render() {
    return (
      <div className="text-center">
        {this.state.loading === true ? (
          <div>
            <div className="loading-text">LOADING</div>
            <img src={spinner} alt="spinner" className="spinner spinning" />
          </div>
        ) : (
          <div>
            {this.state.users
              .sort((a, b) => b.honor - a.honor)
              .map(el => (
                <div key={el.username}>
                  <Box display='flex' justifyContent='space-around' alignItems='center' gap='1rem'>
                    <div className={`codewars-name ${breakpoint() === 'XS' ? 'codewars-name-xs font-sm' : ''}`}>
                      <div>{el.name}</div>
                      <a href={codeWarsUser + el.username} target="_blank" className="link" rel="noopener noreferrer">
                        <div className="font-sm">{el.username}</div>
                      </a>
                    </div>
                    <div className={`codewars-points ${breakpoint() === 'XS' ? 'codewars-points-xs font-sm' : ''}`}>
                      {el.honor}
                    </div>
                    <div className={`codewars-button ${breakpoint() === 'XS' ? 'font-sm' : ''}`}>
                      <Button
                        className={`btn-sm`}
                        variant="outline-dark"
                        onClick={() => this.showHide(el.username)}
                      >
                        {this.state.collapse[el.username] ? "Hide" : "Show"}
                      </Button>
                    </div>
                  </Box>

                  <Box className={breakpoint() === 'XS' ? 'font-sm' : ''}>
                    <Collapse isOpen={this.state.collapse[el.username]}>
                      {Object.keys(tasksToDo).map((block, index) => {
                        return (
                          <div key={index}>
                            <div className="block-tittle">{block}</div>
                            {tasksToDo[block].map(task => (
                              <div className="text-left" key={Math.floor(Math.random() * 1000000)}>
                                {el.kata && el.kata.find(tk => tk && tk.name && tk.name.trim().toLowerCase() === task.name.trim().toLowerCase()) !== undefined ? (
                                  <img src={checkIcon} alt="done" className="mr-1" height={16} />
                                ) : (
                                  <img src={todoIcon} alt="todo" className="mr-1" height={16} />
                                )}
                                <a href={task.link} target="_blank" rel="noopener noreferrer">
                                  {task.name}
                                </a>
                              </div>
                            ))}
                          </div>
                        );
                      })}
                    </Collapse>
                  </Box>
                  <hr></hr>
                </div>
              ))}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(CodeWars);
